export enum AuthStepEnum {
  LOGIN,
  CONFIRMATION,
  AUTHORIZED,
}
